import React from 'react';
import { Icon, Divider, Row, Col } from 'antd';
import { DualAxes, Bar, Area, Pie, Column } from '@antv/g2plot';
import 'antd/dist/antd.css';
import './dataView.css';
import '../../scripts/config'

class DataViewTwoPage extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data1: [
                { time: '2020-05', value: 102, type: '建档人数' },
                { time: '2020-06', value: 86, type: '建档人数' },
                { time: '2020-07', value: 79, type: '建档人数' },
                { time: '2020-08', value: 115, type: '建档人数' },
                { time: '2020-09', value: 63, type: '建档人数' },
                { time: '2020-10', value: 58, type: '建档人数' },
                { time: '2020-11', value: 69, type: '建档人数' },
                { time: '2020-12', value: 41, type: '建档人数' },
                { time: '2021-01', value: 70, type: '建档人数' },
                { time: '2021-02', value: 29, type: '建档人数' },
                { time: '2021-03', value: 61, type: '建档人数' },
                { time: '2021-04', value: 58, type: '建档人数' },
                { time: '2020-05', value: 64, type: '早孕建档' },
                { time: '2020-06', value: 40, type: '早孕建档' },
                { time: '2020-07', value: 24, type: '早孕建档' },
                { time: '2020-08', value: 68, type: '早孕建档' },
                { time: '2020-09', value: 47, type: '早孕建档' },
                { time: '2020-10', value: 24, type: '早孕建档' },
                { time: '2020-11', value: 18, type: '早孕建档' },
                { time: '2020-12', value: 36, type: '早孕建档' },
                { time: '2021-01', value: 18, type: '早孕建档' },
                { time: '2021-02', value: 39, type: '早孕建档' },
                { time: '2021-03', value: 42, type: '早孕建档' },
                { time: '2021-04', value: 21, type: '早孕建档' }
            ],
            data2: [
                { time: '2020-06', count: 40.7, type: '早孕建档率' },
                { time: '2020-07', count: 20.6, type: '早孕建档率' },
                { time: '2020-08', count: 86.4, type: '早孕建档率' },
                { time: '2020-09', count: 37.2, type: '早孕建档率' },
                { time: '2020-10', count: 31.9, type: '早孕建档率' },
                { time: '2020-11', count: 12.6, type: '早孕建档率' },
                { time: '2020-12', count: 51.1, type: '早孕建档率' },
                { time: '2021-01', count: 32.8, type: '早孕建档率' },
                { time: '2021-02', count: 17.4, type: '早孕建档率' },
                { time: '2021-03', count: 36.6, type: '早孕建档率' },
                { time: '2021-04', count: 54.2, type: '早孕建档率' }
            ],
            data3: [
                { time: '2020-05', value: 98, type: '筛查人数' },
                { time: '2020-06', value: 79, type: '筛查人数' },
                { time: '2020-07', value: 85, type: '筛查人数' },
                { time: '2020-08', value: 101, type: '筛查人数' },
                { time: '2020-09', value: 60, type: '筛查人数' },
                { time: '2020-10', value: 51, type: '筛查人数' },
                { time: '2020-11', value: 58, type: '筛查人数' },
                { time: '2020-12', value: 39, type: '筛查人数' },
                { time: '2021-01', value: 68, type: '筛查人数' },
                { time: '2021-02', value: 19, type: '筛查人数' },
                { time: '2021-03', value: 54, type: '筛查人数' },
                { time: '2021-04', value: 49, type: '筛查人数' },
                { time: '2020-05', value: 54, type: '孕早期筛查' },
                { time: '2020-06', value: 41, type: '孕早期筛查' },
                { time: '2020-07', value: 32, type: '孕早期筛查' },
                { time: '2020-08', value: 51, type: '孕早期筛查' },
                { time: '2020-09', value: 36, type: '孕早期筛查' },
                { time: '2020-10', value: 18, type: '孕早期筛查' },
                { time: '2020-11', value: 9, type: '孕早期筛查' },
                { time: '2020-12', value: 22, type: '孕早期筛查' },
                { time: '2021-01', value: 14, type: '孕早期筛查' },
                { time: '2021-02', value: 26, type: '孕早期筛查' },
                { time: '2021-03', value: 31, type: '孕早期筛查' },
                { time: '2021-04', value: 14, type: '孕早期筛查' }
            ],
            data4: [
                { time: '2020-06', count: 1.2, type: '阳性确诊率' },
                { time: '2020-07', count: 0.3, type: '阳性确诊率' },
                { time: '2020-08', count: 2.1, type: '阳性确诊率' },
                { time: '2020-09', count: 0.3, type: '阳性确诊率' },
                { time: '2020-10', count: 1.1, type: '阳性确诊率' },
                { time: '2020-11', count: 0.6, type: '阳性确诊率' },
                { time: '2020-12', count: 0.5, type: '阳性确诊率' },
                { time: '2021-01', count: 1.8, type: '阳性确诊率' },
                { time: '2021-02', count: 2.4, type: '阳性确诊率' },
                { time: '2021-03', count: 0.9, type: '阳性确诊率' },
                { time: '2021-04', count: 3.1, type: '阳性确诊率' }
            ],
            data5: [
                { year: '在管孕妇总数', value: 684 },
                { year: '本月新增孕妇总数', value: 102 },
                { year: '在管高危孕妇总数', value: 302 },
                { year: '本月新增高危孕妇总数', value: 45 },
                { year: '下月预计高危妊娠分娩总数', value: 62 },
            ],
            data6: [
                { time: '2020-05', value: 23, type: '黄色风险因素' },
                { time: '2020-06', value: 15, type: '黄色风险因素' },
                { time: '2020-07', value: 24, type: '黄色风险因素' },
                { time: '2020-08', value: 36, type: '黄色风险因素' },
                { time: '2020-09', value: 40, type: '黄色风险因素' },
                { time: '2020-10', value: 8, type: '黄色风险因素' },
                { time: '2020-11', value: 15, type: '黄色风险因素' },
                { time: '2020-12', value: 19, type: '黄色风险因素' },
                { time: '2021-01', value: 22, type: '黄色风险因素' },
                { time: '2021-02', value: 36, type: '黄色风险因素' },
                { time: '2021-03', value: 40, type: '黄色风险因素' },
                { time: '2021-04', value: 67, type: '黄色风险因素' },

                { time: '2020-05', value: 10, type: '橙色风险因素' },
                { time: '2020-06', value: 2, type: '橙色风险因素' },
                { time: '2020-07', value: 0, type: '橙色风险因素' },
                { time: '2020-08', value: 6, type: '橙色风险因素' },
                { time: '2020-09', value: 4, type: '橙色风险因素' },
                { time: '2020-10', value: 2, type: '橙色风险因素' },
                { time: '2020-11', value: 0, type: '橙色风险因素' },
                { time: '2020-12', value: 2, type: '橙色风险因素' },
                { time: '2021-01', value: 10, type: '橙色风险因素' },
                { time: '2021-02', value: 6, type: '橙色风险因素' },
                { time: '2021-03', value: 9, type: '橙色风险因素' },
                { time: '2021-04', value: 21, type: '橙色风险因素' },

                { time: '2020-05', value: 4, type: '红色风险因素' },
                { time: '2020-06', value: 0, type: '红色风险因素' },
                { time: '2020-07', value: 0, type: '红色风险因素' },
                { time: '2020-08', value: 0, type: '红色风险因素' },
                { time: '2020-09', value: 2, type: '红色风险因素' },
                { time: '2020-10', value: 0, type: '红色风险因素' },
                { time: '2020-11', value: 1, type: '红色风险因素' },
                { time: '2020-12', value: 4, type: '红色风险因素' },
                { time: '2021-01', value: 0, type: '红色风险因素' },
                { time: '2021-02', value: 5, type: '红色风险因素' },
                { time: '2021-03', value: 9, type: '红色风险因素' },
                { time: '2021-04', value: 12, type: '红色风险因素' },

                { time: '2020-05', value: 0, type: '紫色风险因素' },
                { time: '2020-06', value: 0, type: '紫色风险因素' },
                { time: '2020-07', value: 0, type: '紫色风险因素' },
                { time: '2020-08', value: 0, type: '紫色风险因素' },
                { time: '2020-09', value: 1, type: '紫色风险因素' },
                { time: '2020-10', value: 0, type: '紫色风险因素' },
                { time: '2020-11', value: 2, type: '紫色风险因素' },
                { time: '2020-12', value: 0, type: '紫色风险因素' },
                { time: '2021-01', value: 0, type: '紫色风险因素' },
                { time: '2021-02', value: 0, type: '紫色风险因素' },
                { time: '2021-03', value: 0, type: '紫色风险因素' },
                { time: '2021-04', value: 1, type: '紫色风险因素' },
            ],
            data7: [
                { type: '按时随访', value: 302 },
                { type: '超期随访', value: 26 },
                { type: '流失人数', value: 2 }
            ],
            data8: [
                { time: '孕14周', value: 203, type: '预约人数' },
                { time: '孕20周', value: 318, type: '预约人数' },
                { time: '孕24周', value: 198, type: '预约人数' },
                { time: '孕28周', value: 244, type: '预约人数' },
                { time: '孕32周', value: 148, type: '预约人数' },
                { time: '孕36周', value: 302, type: '预约人数' },
                { time: '孕37周', value: 146, type: '预约人数' },
                { time: '孕38周', value: 181, type: '预约人数' },
                { time: '孕39周', value: 211, type: '预约人数' },
                { time: '孕40周', value: 187, type: '预约人数' },
                { time: '孕41周', value: 270, type: '预约人数' },

                { time: '孕14周', value: 199, type: '到检人数' },
                { time: '孕20周', value: 318, type: '到检人数' },
                { time: '孕24周', value: 196, type: '到检人数' },
                { time: '孕28周', value: 211, type: '到检人数' },
                { time: '孕32周', value: 120, type: '到检人数' },
                { time: '孕36周', value: 299, type: '到检人数' },
                { time: '孕37周', value: 145, type: '到检人数' },
                { time: '孕38周', value: 169, type: '到检人数' },
                { time: '孕39周', value: 204, type: '到检人数' },
                { time: '孕40周', value: 187, type: '到检人数' },
                { time: '孕41周', value: 251, type: '到检人数' },

                { time: '孕14周', value: 4, type: '流失人数' },
                { time: '孕20周', value: 0, type: '流失人数' },
                { time: '孕24周', value: 2, type: '流失人数' },
                { time: '孕28周', value: 33, type: '流失人数' },
                { time: '孕32周', value: 28, type: '流失人数' },
                { time: '孕36周', value: 6, type: '流失人数' },
                { time: '孕37周', value: 1, type: '流失人数' },
                { time: '孕38周', value: 12, type: '流失人数' },
                { time: '孕39周', value: 0, type: '流失人数' },
                { time: '孕40周', value: 19, type: '流失人数' },
                { time: '孕41周', value: 4, type: '流失人数' },
            ],
            data9: [
                { time: '年龄＜18', value: 305 },
                { time: '年龄≥35岁', value: 305 },
                { time: '孕前BMI＞25', value: 189 },
                { time: '生殖道畸形/盆骨异常', value: 12 },
                { time: '各类流产≥3次', value: 69 },
                { time: '死胎死产、早产≥2次', value: 26 },
                { time: '疤痕子宫', value: 102 },
                { time: '辅助生殖妊娠', value: 4 }
            ],
            data10: [
                { time: '内分泌系统疾病', value: 21 },
                { time: '高血压疾病', value: 68 },
                { time: '胎盘异常', value: 4 },
                { time: '血液系统疾病', value: 106 },
                { time: '心血管系统疾病', value: 19 },
                { time: '消化系统疾病', value: 27 },
                { time: '泌尿系统疾病', value: 12 },
                { time: '免疫系统疾病', value: 3 },
                { time: '神经系统疾病', value: 0 },
                { time: '≥36周胎位异常', value: 5 },
                { time: '多胎妊娠', value: 25 },
                { time: '传染性疾病', value: 1 }
            ]
        }
    };
    //组件载入完成
    componentDidMount() {
        this.chartOneInit();
        this.chartTwoInit();
        this.chartThreeInit();
        this.chartFourInit();
        this.chartFiveInit();
        this.chartSevenInit();
        this.chartSixInit();
        this.chartEightInit();
    }
    chartOneInit = () => {
        const uvBillData = this.state.data1;
        const transformData = this.state.data2;
        const dualAxes = new DualAxes('chartOnecontainer', {
            data: [uvBillData, transformData],
            xField: 'time',
            yField: ['value', 'count'],
            geometryOptions: [
                {
                    geometry: 'column',
                    isGroup: true,
                    seriesField: 'type',
                    color: ['#0DB65F', '#E6ED12'],
                },
                {
                    geometry: 'line',
                    lineStyle: {
                        lineWidth: 2,
                    },
                    seriesField: 'type',
                    color: ['#F8BA0C'],
                },
            ],
        });

        dualAxes.render();
    }

    chartTwoInit = () => {
        const uvBillData = this.state.data3;
        const transformData = this.state.data4;
        const dualAxes = new DualAxes('chartTwocontainer', {
            data: [uvBillData, transformData],
            xField: 'time',
            yField: ['value', 'count'],
            geometryOptions: [
                {
                    geometry: 'column',
                    isGroup: true,
                    seriesField: 'type',
                    color: ['#0DF54C', '#0FBFE7'],
                },
                {
                    geometry: 'line',
                    lineStyle: {
                        lineWidth: 2,
                    },
                    seriesField: 'type',
                    color: ['#FFFFFF'],
                },
            ],
        });

        dualAxes.render();
    }

    chartThreeInit = () => {
        const data = this.state.data5;
        const bar = new Bar('chartThreecontainer', {
            data,
            xField: 'value',
            yField: 'year',
            color: ['#F4032D', '#EE1818', '#F88F06', '#0FBFE7', '#0DF54C'],
            seriesField: 'year',
            legend: {
                position: 'bottom',
            },
        });

        bar.render();
    }
    chartFourInit = () => {
        const data = this.state.data6;
        const area = new Area('chartFourcontainer', {
            data,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            color: ['yellow', 'orange', 'red', 'purple'],
            areaStyle: {
                fillOpacity: 0.7,
            },
            appendPadding: 10,
            isPercent: true,
            yAxis: {
                label: {
                    formatter: (value) => {
                        return value;
                    },
                },
            },
        });
        area.render();
    }
    chartFiveInit = () => {
        const data = this.state.data7;
        const piePlot = new Pie('chartFivecontainer', {
            appendPadding: 10,
            data,
            angleField: 'value',
            colorField: 'type',
            radius: 0.75,
            color: ['#0AF80A', '#F8900A', '#F80A0A'],
            label: {
                type: 'spider',
                labelHeight: 28,
                content: '{name}\n{percentage}',
            },
            legend: {
                position: 'bottom',
            },
            interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
        });

        piePlot.render();
    }
    chartSixInit = () => {
        const data = this.state.data9;
        const stackedColumnPlot = new Column('chartSixcontainer', {
            data,
            isGroup: false,
            xField: 'time',
            yField: 'value',
            legend: {
                position: 'bottom',
            },
            color: ({ time }) => {
                const _color=time==='年龄≥35岁'?'#F6AD13':
                time==='孕前BMI＞25'?'#F6AD13':'#EDF40B';
                return _color;
              },
            /** 设置间距 */
            // marginRatio: 0.1,
            label: {
                // 可手动配置 label 数据标签位置
                position: 'top', // 'top', 'middle', 'bottom'
                // 可配置附加的布局方法
                layout: [
                    // 柱形图数据标签位置自动调整
                    { type: 'interval-adjust-position' },
                    // 数据标签防遮挡
                    { type: 'interval-hide-overlap' },
                    // 数据标签文颜色自动调整
                    { type: 'adjust-color' },
                ],
            },
        });

        stackedColumnPlot.render();
    }
    chartSevenInit = () => {
        const data = this.state.data8;
        const stackedColumnPlot = new Column('chartSevencontainer', {
            data,
            isGroup: true,
            xField: 'time',
            yField: 'value',
            seriesField: 'type',
            legend: {
                position: 'bottom',
            },
            color: ['#1BF5F7', '#0DF223', '#F21A0D'],
            /** 设置间距 */
            // marginRatio: 0.1,
            label: {
                // 可手动配置 label 数据标签位置
                position: 'top', // 'top', 'middle', 'bottom'
                // 可配置附加的布局方法
                layout: [
                    // 柱形图数据标签位置自动调整
                    { type: 'interval-adjust-position' },
                    // 数据标签防遮挡
                    { type: 'interval-hide-overlap' },
                    // 数据标签文颜色自动调整
                    { type: 'adjust-color' },
                ],
            },
        });

        stackedColumnPlot.render();
    }
    chartEightInit = () => {
        const data = this.state.data10;
        const stackedColumnPlot = new Column('chartEightcontainer', {
            data,
            isGroup: false,
            xField: 'time',
            yField: 'value',
            legend: {
                position: 'bottom',
            },
            color: ({ time }) => {
                const _color=time==='传染性疾病'?'#BC29FB':'#F81212';
                return _color;
              },
            /** 设置间距 */
            // marginRatio: 0.1,
            label: {
                // 可手动配置 label 数据标签位置
                position: 'top', // 'top', 'middle', 'bottom'
                // 可配置附加的布局方法
                layout: [
                    // 柱形图数据标签位置自动调整
                    { type: 'interval-adjust-position' },
                    // 数据标签防遮挡
                    { type: 'interval-hide-overlap' },
                    // 数据标签文颜色自动调整
                    { type: 'adjust-color' },
                ],
            },
        });

        stackedColumnPlot.render();
    }
    render() {
        return (
            <div>
                <Row gutter={4} className="div-c-charts">
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='line-chart'></Icon><Divider type='vertical'></Divider>建档数据分析</div>
                            <div id='chartOnecontainer'></div>
                        </div>
                    </Col>

                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='exception'></Icon><Divider type='vertical'></Divider>三病筛查分析</div>
                            <div id='chartTwocontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='line-chart'></Icon><Divider type='vertical'></Divider>高危管理分析</div>
                            <div id='chartThreecontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='schedule'></Icon><Divider type='vertical'></Divider>高危筛查分析</div>
                            <div id='chartFourcontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='apartment'></Icon><Divider type='vertical'></Divider>随访管理分析</div>
                            <div id='chartFivecontainer'></div>
                        </div>
                    </Col>
                    <Col span={18}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='alert'></Icon><Divider type='vertical'></Divider>固定高危因素分析</div>
                            <div id='chartSixcontainer'></div>
                        </div>
                    </Col>
                    <Col span={6}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='book'></Icon><Divider type='vertical'></Divider>按时产检分析</div>
                            <div id='chartSevencontainer'></div>
                        </div>
                    </Col>
                    <Col span={18}>
                        <div className="div-c-charts-content">
                            <div className="div-c-charts-content-title"><Icon type='thunderbolt'></Icon><Divider type='vertical'></Divider>活动高危因素分析</div>
                            <div id='chartEightcontainer'></div>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}
export default DataViewTwoPage;